export enum LocalStorageKey {
  ColorMode = "ColorMode",
}
